<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="contenedorprincipal">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">
                {{this.TituloOpcionMenu()}}
            </h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-sm-12 col-md-9 d-flex flex-column">
            <div class="row w-100">
                <div class="col-11 contenedorremoverpadding">
                    <div class="d-flex">
                        <div class="flex-fill flex-column">
                            <div class="contenedorencabezado contenedorpaddinginterno contenedorborderizquierdo align-content-center cursorpointer" (click)="CambiarValorContenido()">
                                <p class="tituloprincipalexpansionpanel">Servicio</p>
                            </div>
                            <div class="contenedorencabezadodatos contenedorpaddinginterno align-content-center" *ngIf="this.mostrarContenidoPrincipal">
                                <p class="descripcionprincipalexpansionpanel">{{this.itemDetalleInformacionGeneral.servicio}}</p>
                            </div>
                        </div>
                        <div class="flex-fill flex-column">
                            <div class="contenedorencabezado contenedorpaddinginterno align-content-center cursorpointer" (click)="CambiarValorContenido()">
                                <p class="tituloprincipalexpansionpanel">Subservicio</p>
                            </div>
                            <div class="contenedorencabezadodatos contenedorpaddinginterno align-content-center" *ngIf="this.mostrarContenidoPrincipal">
                                <p class="descripcionprincipalexpansionpanel">{{this.itemDetalleInformacionGeneral.subServicio}}</p>
                            </div>
                        </div>
                        <div class="flex-fill flex-column">
                            <div class="contenedorencabezado contenedorpaddinginterno align-content-center cursorpointer" (click)="CambiarValorContenido()">
                                <p class="tituloprincipalexpansionpanel">Eventos incluidos</p>
                            </div>
                            <div class="contenedorencabezadodatos contenedorpaddinginterno align-content-center" *ngIf="this.mostrarContenidoPrincipal">
                                <p class="descripcionprincipalexpansionpanel">{{this.itemDetalleInformacionGeneral.eventosIncluidos}}</p>
                            </div>
                        </div>
                        <div class="flex-fill flex-column">
                            <div class="contenedorencabezado contenedorpaddinginterno align-content-center cursorpointer" (click)="CambiarValorContenido()">
                                <p class="tituloprincipalexpansionpanel">Eventos disponibles</p>
                            </div>
                            <div class="contenedorencabezadodatos contenedorpaddinginterno align-content-center" *ngIf="this.mostrarContenidoPrincipal">
                                <p class="descripcionprincipalexpansionpanel">{{this.itemDetalleInformacionGeneral.eventosDisponibles}}</p>
                            </div>
                        </div>
                        <div class="flex-fill flex-column">
                            <div class="contenedorencabezado contenedorpaddinginterno align-content-center cursorpointer" (click)="CambiarValorContenido()">
                                <p class="tituloprincipalexpansionpanel">Monto máximo de cobertura</p>
                            </div>
                            <div class="contenedorencabezadodatos contenedorpaddinginterno align-content-center" *ngIf="this.mostrarContenidoPrincipal">
                                <p class="descripcionprincipalexpansionpanel">{{this.itemDetalleInformacionGeneral.montoMaximoCobertura}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-1 contenedorremoverpadding">
                    <div class="contenedorencabezado contenedorpaddinginternoflecha contenedorborderderecho cursorpointer" (click)="CambiarValorContenido()">
                        <mat-icon class="iconoprincipalexpansionpanel">
                            {{this.mostrarContenidoPrincipal ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                        </mat-icon>
                    </div>
                    <div class="contenedorencabezadodatos align-content-center" *ngIf="this.mostrarContenidoPrincipal">
                        <p class="descripcionprincipalexpansionpanel"></p>
                    </div>
                </div>
            </div>
            <div class="row w-100 mt-3">
                <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="CambioTabSeleccionado($event)">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span>Expediente</span>
                        </ng-template>
                        <div>
                            <div class="pl-0 pr-0 mat-elevation-z8">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="dataSourceExpedientes" matSort class="table table-striped table-hover">
                        
                                        <!-- nro Column -->
                                        <ng-container matColumnDef="nro">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.id}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- asunto Column -->
                                        <ng-container matColumnDef="asunto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Asunto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)" *ngIf="!this.EsOcurrido(row) && !this.EsObservaciones(row)">
                                                    {{this.TextoReducidoDescripcion(row.asunto, 100)}} 
                                                </a>
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)" *ngIf="this.EsOcurrido(row)">
                                                    Ocurrido...
                                                </a>
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)" *ngIf="this.EsObservaciones(row)">
                                                    Observaciones...
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- concepto Column -->
                                        <ng-container matColumnDef="concepto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Concepto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.concepto}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- fecha Column -->
                                        <ng-container matColumnDef="fecha">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.fecha | fechapipe:true}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- accion Column -->
                                        <ng-container matColumnDef="accion">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                <mat-icon class="iconotituloexpediente">
                                                    attach_file
                                                </mat-icon>
                                            </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="DescargarAdjuntoDetalleExpendiente(row)" *ngIf="row.concepto === this.CONCEPTO_ADJUNTO">
                                                    <mat-icon>
                                                        attach_file
                                                    </mat-icon>
                                                </a>
                                            </td>
                                        </ng-container>
                        
                                        <tr mat-header-row *matHeaderRowDef="columnasExpedientes"></tr>
                                        <tr mat-row *matRowDef="let row; columns: columnasExpedientes;"></tr>
                        
                                        <!-- Row shown when there is no matching data. -->
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <mat-paginator #paginatorExpedientes="matPaginator" [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span>Ocurrido</span>
                        </ng-template>
                        <div>
                            <div class="pl-0 pr-0 mat-elevation-z8">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="dataSourceOcurrido" matSort class="table table-striped table-hover">
                        
                                        <!-- nro Column -->
                                        <ng-container matColumnDef="nro">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.id}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- asunto Column -->
                                        <ng-container matColumnDef="asunto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Asunto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)" *ngIf="this.EsOcurrido(row)">
                                                    Ocurrido...
                                                </a>
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)" *ngIf="this.EsObservaciones(row)">
                                                    Observaciones...
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- concepto Column -->
                                        <ng-container matColumnDef="concepto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Concepto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.concepto}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- fecha Column -->
                                        <ng-container matColumnDef="fecha">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.fecha | fechapipe:true}} 
                                                </a>
                                            </td>
                                        </ng-container>
                        
                                        <tr mat-header-row *matHeaderRowDef="columnasOcurrido"></tr>
                                        <tr mat-row *matRowDef="let row; columns: columnasOcurrido;"></tr>
                        
                                        <!-- Row shown when there is no matching data. -->
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <mat-paginator #paginatorOcurrido="matPaginator" [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span>Asignación</span>
                        </ng-template>
                        <div>
                            <div class="pl-0 pr-0 mat-elevation-z8">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="dataSourceAsignacion" matSort class="table table-striped table-hover">
                        
                                        <!-- nro Column -->
                                        <ng-container matColumnDef="nro">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.id}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- asunto Column -->
                                        <ng-container matColumnDef="asunto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Asunto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{this.TextoReducidoDescripcion(row.asunto, 100)}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- concepto Column -->
                                        <ng-container matColumnDef="concepto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Concepto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.concepto}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- fecha Column -->
                                        <ng-container matColumnDef="fecha">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.fecha | fechapipe:true}} 
                                                </a>
                                            </td>
                                        </ng-container>
                        
                                        <tr mat-header-row *matHeaderRowDef="columnasAsignacion"></tr>
                                        <tr mat-row *matRowDef="let row; columns: columnasAsignacion;"></tr>
                        
                                        <!-- Row shown when there is no matching data. -->
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <mat-paginator #paginatorAsignacion="matPaginator" [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span>Monitoreo</span>
                        </ng-template>
                        <div>
                            <div class="pl-0 pr-0 mat-elevation-z8">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="dataSourceMonitoreo" matSort class="table table-striped table-hover">
                        
                                        <!-- nro Column -->
                                        <ng-container matColumnDef="nro">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.id}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- asunto Column -->
                                        <ng-container matColumnDef="asunto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Asunto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{this.TextoReducidoDescripcion(row.asunto, 100)}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- concepto Column -->
                                        <ng-container matColumnDef="concepto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Concepto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.concepto}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- fecha Column -->
                                        <ng-container matColumnDef="fecha">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.fecha | fechapipe:true}} 
                                                </a>
                                            </td>
                                        </ng-container>
                        
                                        <tr mat-header-row *matHeaderRowDef="columnasMonitoreo"></tr>
                                        <tr mat-row *matRowDef="let row; columns: columnasMonitoreo;"></tr>
                        
                                        <!-- Row shown when there is no matching data. -->
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <mat-paginator #paginatorMonitoreo="matPaginator" [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span>Adjuntos</span>
                        </ng-template>
                        <div>
                            <div class="pl-0 pr-0 mat-elevation-z8">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="dataSourceAdjuntos" matSort class="table table-striped table-hover">
                        
                                        <!-- nro Column -->
                                        <ng-container matColumnDef="nro">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.id}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- asunto Column -->
                                        <ng-container matColumnDef="asunto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Asunto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{this.TextoReducidoDescripcion(row.asunto, 100)}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- concepto Column -->
                                        <ng-container matColumnDef="concepto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Concepto </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.concepto}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- fecha Column -->
                                        <ng-container matColumnDef="fecha">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="AbrirDetalleExpendiente(row)">
                                                    {{row.fecha | fechapipe:true}} 
                                                </a>
                                            </td>
                                        </ng-container>
                                        <!-- accion Column -->
                                        <ng-container matColumnDef="accion">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                <mat-icon class="iconotituloexpediente">
                                                    attach_file
                                                </mat-icon>
                                            </th>
                                            <td mat-cell *matCellDef="let row"> 
                                                <a type="button" (click)="DescargarAdjuntoDetalleExpendiente(row)" *ngIf="row.concepto === this.CONCEPTO_ADJUNTO">
                                                    <mat-icon>
                                                        attach_file
                                                    </mat-icon>
                                                </a>
                                            </td>
                                        </ng-container>
                        
                                        <tr mat-header-row *matHeaderRowDef="columnasAdjuntos"></tr>
                                        <tr mat-row *matRowDef="let row; columns: columnasAdjuntos;"></tr>
                        
                                        <!-- Row shown when there is no matching data. -->
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div>
                                <mat-paginator #paginatorAdjuntos="matPaginator" [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                            </div>
                        </div>
                    </mat-tab>
                    
                </mat-tab-group>
            </div>
            <div class="row w-100 mt-3">
                <div class="contenedordetalleexpediente d-flex flex-row flex-wrap bd-highlight cursorpointer" (click)="this.CambiarContenidoDetalleExpediente()">
                    <div class="p-1">
                        <mat-icon class="iconodetallexpediente">
                            {{this.mostrarContenidoDetalleExpediente ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                        </mat-icon>
                    </div>
                    <div class="p-1">
                        <p class="titulodetalleexpediente">#{{this.itemDetalleExpedientes.id}}</p>
                    </div>
                    <div class="p-1">
                        <p class="titulodetalleexpediente">Asunto:</p>
                    </div>
                    <div class="p-1">
                        <p class="descripciondetalleexpediente" *ngIf="this.EsOcurrido(this.itemDetalleExpedientes)">
                            Ocurrido...
                        </p>
                        <p class="descripciondetalleexpediente" *ngIf="this.EsObservaciones(this.itemDetalleExpedientes)">
                            Observaciones...
                        </p>
                        <p class="descripciondetalleexpediente" *ngIf="!this.EsOcurrido(this.itemDetalleExpedientes) && !this.EsObservaciones(this.itemDetalleExpedientes)">
                            {{this.TextoReducidoDescripcion(this.itemDetalleExpedientes.asunto, 50)}}
                        </p>
                    </div>
                    <div class="p-1">
                        <p class="titulodetalleexpediente">Concepto:</p>
                    </div>
                    <div class="p-1">
                        <p class="descripciondetalleexpediente">{{this.itemDetalleExpedientes.concepto}}</p>
                    </div>
                    <div class="p-1">
                        <p class="titulodetalleexpediente">Fecha:</p>
                    </div>
                    <div class="p-1">
                        <p class="descripciondetalleexpediente">{{this.itemDetalleExpedientes.fecha | fechapipe:true}}</p>
                    </div>
                </div>
                <div class="contenedordescripciondetalleexpediente" *ngIf="this.mostrarContenidoDetalleExpediente">
                    <p class="descripcioncontenidodetalleexpediente" *ngIf="!this.EsHTML(this.itemDetalleExpedientes)">
                        {{this.itemDetalleExpedientes.asunto}}
                    </p>
                    <div [innerHTML]="this.itemDetalleExpedientes.asunto" *ngIf="this.EsHTML(this.itemDetalleExpedientes)"></div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-3 d-flex flex-column" [ngClass]="{'contenedorderechoprincipal': this.AgregarClaseMargenTamanoDerecho()}">
            <div class="contenedorencabezado contenedorborderarriba d-flex bd-highlight cursorpointer" (click)="this.CambiarValorInformacionAfiliado()">
                <div class="p-1 flex-fill bd-highlight">
                    <p class="tituloprincipalexpansionpanel margentituloinformacionadicional">Información afiliado</p>
                </div>
                <div class="p-1 flex-fill bd-highlight">
                    <mat-icon class="iconoprincipalexpansionpanel">
                        {{this.mostrarContenidoInformacionAfiliado ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
            </div>
            <div class="contenedorsecundario d-flex bd-highlight cursorpointer" (click)="this.CambiarDatosAfiliado()" *ngIf="this.mostrarContenidoInformacionAfiliado">
                <div class="p-1 flex-fill bd-highlight">
                    <p class="titulosecundarioexpansionpanel">Datos del Afiliado</p>
                </div>
                <div class="p-1 flex-fill bd-highlight">
                    <mat-icon class="iconosecundarioexpansionpanel">
                        {{this.mostrarContenidoDatosAfiliado ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
            </div>
            <div class="contenedordatos" *ngIf="this.mostrarContenidoInformacionAfiliado && this.mostrarContenidoDatosAfiliado">
                <div class="contenedordatosinterno d-flex flex-column bd-highlight">
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Identificación: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.identificacion}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Nombre: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.nombre}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Apellido: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.apellido}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Celular: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.celular}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Fijo: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.fijo}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Departamento: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.departamento}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Ciudad: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.ciudad}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Dirección: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.direccion}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <mat-icon class="iconoalerta cursorpointer" (click)="this.VerExpedientesAbiertos()">
                            warning
                        </mat-icon>
                        <p class="descripcioncontenidofinal cursorpointer" (click)="this.VerExpedientesAbiertos()">Expedientes abiertos <b>({{this.itemDetalleInformacionGeneral.expedientesabiertos}})</b></p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <mat-icon class="cursorpointer" (click)="this.VerInformacionAdicional()">
                            remove_red_eye
                        </mat-icon>
                        <p class="descripcioncontenidofinal cursorpointer" (click)="this.VerInformacionAdicional()">Ver más información del afiliado</p>
                    </div>
                </div>
            </div>
            <div class="contenedorsecundario d-flex bd-highlight cursorpointer" (click)="this.CambiarDatosContactante()" *ngIf="this.mostrarContenidoInformacionAfiliado">
                <div class="p-1 flex-fill bd-highlight">
                    <p class="titulosecundarioexpansionpanel">Datos del contactante</p>
                </div>
                <div class="p-1 flex-fill bd-highlight">
                    <mat-icon class="iconosecundarioexpansionpanel">
                        {{this.mostrarContenidoDatosContactante ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
            </div>
            <div class="contenedordatos" *ngIf="this.mostrarContenidoInformacionAfiliado && this.mostrarContenidoDatosContactante">
                <div class="contenedordatosinterno d-flex flex-column bd-highlight">
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Nombre: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.nombreContacto}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Apellido: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.apellidoContacto}}</p>
                    </div>
                </div>
            </div>

            <div class="contenedorencabezado contenedorborderarriba d-flex bd-highlight cursorpointer mt-3" (click)="this.CambiarInformacionExpediente()">
                <div class="p-1 flex-fill bd-highlight">
                    <p class="tituloprincipalexpansionpanel margentituloinformacionadicional">Información del expediente</p>
                </div>
                <div class="p-1 flex-fill bd-highlight">
                    <mat-icon class="iconoprincipalexpansionpanel">
                        {{this.mostrarContenidoInformacionExpediente ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
            </div>
            <div class="contenedordatos" *ngIf="this.mostrarContenidoInformacionExpediente">
                <div class="contenedordatosinterno d-flex flex-column bd-highlight">
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Estado: </p>
                        <div [class]="this.ClaseEstadoEspediente()">
                            {{this.itemDetalleInformacionGeneral.estado}}
                        </div>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Creado: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.fechaCreacion | fechapipe}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Tipo: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.tipo}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Sponsor / canal: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.canal}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Cliente: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.cliente}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Programa: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.producto}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Servicio: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.servicio}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Subservicio: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.subServicio}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Cola: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.cola}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Propietario: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.priopetario}}</p>
                    </div>
                    <div class="p-1 d-flex flex-row bd-highlight">
                        <p class="titulodescripcioncontenido">Responsable: </p>
                        <p class="descripcioncontenido">{{this.itemDetalleInformacionGeneral.responsable}}</p>
                    </div>
                </div>
            </div>

            <div class="contenedorencabezado contenedorborderarriba d-flex bd-highlight cursorpointer mt-3" (click)="this.CambiarVistaGeneral()">
                <div class="p-1 flex-fill bd-highlight">
                    <p class="tituloprincipalexpansionpanel margentituloinformacionadicional">Vista general</p>
                </div>
                <div class="p-1 flex-fill bd-highlight">
                    <mat-icon class="iconoprincipalexpansionpanel">
                        {{this.mostrarContenidoVistaGeneral ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
            </div>
            <div class="vistageneralcontenedor d-flex flex-column bd-highlight" *ngIf="this.mostrarContenidoVistaGeneral">
                <div class="d-flex justify-content-center">
                    <div class="vistageneralprimeritem">
                        <p class="vistageneralprimeritemtexto">Apertura expediente {{this.itemDetalleInformacionGeneral.fechaCreacion | fechapipe:true}}</p>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="vistageneralprimeritemadicion"></div>
                </div>
                <div class="d-flex justify-content-center">
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealto" *ngFor="let item of this.listaDetalleVistaGeneral">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                                <div class="vistageneralitemexpediente w-100" *ngIf="ItemEsImpar(item)">
                                    <p class="vistageneralitemexpedientetexto">{{item.concepto}}<br/>{{item.fecha | fechapipe:true}}</p>
                                </div>
                                <div class="vistageneralitemexpedienteizquierda" *ngIf="ItemEsImpar(item)">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealto" *ngFor="let item of this.listaDetalleVistaGeneral">
                            <div class="d-flex flex-column bd-highlight vistageneralitemexpedientelineas">
                                <div class="vistageneralitemexpedientelinea">
                                    <div class="vistageneralitemexpedientecirculo">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealto" *ngFor="let item of this.listaDetalleVistaGeneral">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                                <div class="vistageneralitemexpedientederecha" *ngIf="!ItemEsImpar(item)">
                                </div>
                                <div class="vistageneralitemexpediente w-100" *ngIf="!ItemEsImpar(item)">
                                    <p class="vistageneralitemexpedientetexto">{{item.concepto}}<br/>{{item.fecha | fechapipe:true}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center mt-2" *ngFor="let item of this.listaNumerosAdicion">
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealtoultimo">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealtoultimo">
                            <div class="d-flex flex-column bd-highlight vistageneralitemexpedientelineasultimo">
                                <div class="vistageneralitemexpedientelineaultimo">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealtoultimo">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center" *ngIf="this.itemDetalleInformacionGeneral.codigoEstado === this.ESTADOS_TERMINADO">
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealto">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                                <div class="vistageneralitemexpedientefinal w-100" *ngIf="NumeroEsImpar(this.idFinal)">
                                    <p class="vistageneralitemexpedientetexto">{{this.conceptoFinal}}<br/>{{this.fechaFinal| fechapipe:true}}</p>
                                </div>
                                <div class="vistageneralitemexpedienteizquierdafinal" *ngIf="NumeroEsImpar(this.idFinal)">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealtoultimocirculo">
                            <div class="d-flex flex-column bd-highlight vistageneralitemexpedientelineas">
                                <div class="vistageneralitemexpedientelineafinal">
                                    <div class="vistageneralitemexpedientecirculoultimofinal">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealto">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                                <div class="vistageneralitemexpedientederechafinal" *ngIf="!NumeroEsImpar(this.idFinal)">
                                </div>
                                <div class="vistageneralitemexpedientefinal w-100" *ngIf="!NumeroEsImpar(this.idFinal)">
                                    <p class="vistageneralitemexpedientetexto">{{this.conceptoFinal}}<br/>{{this.fechaFinal| fechapipe:true}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center" *ngIf="this.itemDetalleInformacionGeneral.codigoEstado !== this.ESTADOS_TERMINADO">
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealtoultimocirculo">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealtoultimocirculo">
                            <div class="d-flex flex-column bd-highlight vistageneralitemexpedientelineasultimocirculo">
                                <div class="vistageneralitemexpedientecirculoultimo">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column bd-highlight vistageneralitemexpedientealtoultimocirculo">
                            <div class="vistageneralitemexpedienteanchotexto d-flex justify-content-start">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>